import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { PSelectItem } from '../../../shared/design-system/atoms/p-select/p-select-item.model';
import { ServicePerval } from '../../models/service-perval';

@Component({
  selector: 'app-historique-service-search-form',
  templateUrl: './search-form.component.html',
  styleUrls: ['./search-form.component.scss'],
})
export class SearchFormComponent {
  @Output() searched = new EventEmitter<ServicePerval.SearchParams>();

  services: PSelectItem[] = [
    { value: '', label: null },
    { value: 'LRV', label: 'Liste de références' },
    { value: 'EvAu', label: 'Evaluation automatique' },
    { value: 'Eval', label: 'Evaluation manuelle' },
  ];

  typesDeBiens: PSelectItem[] = [
    { value: '', label: null },
    { value: 'APP', label: 'Appartement' },
    { value: 'MAI', label: 'Maison' },
    { value: 'LAC', label: "Local d'activité" },
    { value: 'TER', label: 'Terrain' },
    { value: 'IMM', label: 'Immeuble' },
    { value: 'GAR', label: 'Garage' },
    { value: 'AGR', label: 'Bien agricole' },
    { value: 'VIG', label: 'Bien viticole' },
  ];

  searchForm = new FormGroup({
    localisation: new FormControl(),
  });

  serviceSelected!: PSelectItem;
  typeDeBienSelected!: PSelectItem;
  localisation!: string;

  public onServiceSelected(service: PSelectItem): void {
    this.serviceSelected = service;
  }

  public onTypeDeBienSelected(typeDeBien: PSelectItem): void {
    this.typeDeBienSelected = typeDeBien;
  }

  public onLocalisationChange(localisation: string): void {
    this.localisation = localisation;
  }

  public resetFilters(): void {
    this.serviceSelected = this.services[0];
    this.typeDeBienSelected = this.typesDeBiens[0];
    this.searchForm.controls.localisation.reset();
    this.localisation = '';
    const searchParams: ServicePerval.SearchParams = {};
    this.searched.emit(searchParams);
  }

  public search(): void {
    const searchParams: ServicePerval.SearchParams = {};

    if (this.serviceSelected?.value && this.serviceSelected.value !== '') {
      searchParams.service = this.serviceSelected.value;
    }

    if (
      this.typeDeBienSelected?.value &&
      this.typeDeBienSelected.value !== ''
    ) {
      searchParams.property_type = this.typeDeBienSelected.value;
    }

    if (this.localisation && this.localisation !== '') {
      searchParams.localisation = this.localisation;
    }

    if (Object.keys(searchParams).length > 0) {
      this.searched.emit(searchParams);
    } else {
      this.searched.emit();
    }
  }
}
